import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { I18nProvider } from './i18n';
import { ErrorBoundary } from './components/ErrorBoundary';
import App from './App';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

// Ne créer la root qu'une seule fois (évite l'avertissement en dev / HMR)
let root = (rootElement as HTMLElement & { _reactRoot?: ReturnType<typeof ReactDOM.createRoot> })._reactRoot;
if (!root) {
  root = ReactDOM.createRoot(rootElement);
  (rootElement as HTMLElement & { _reactRoot?: typeof root })._reactRoot = root;
}
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <I18nProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </I18nProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
);